import { TopBar } from "./types";
import { ROLE } from "./constants";

const defaultState = {
    role: ROLE.LENDER,
    view: "",
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case TopBar.SET_ROLE:
            return {
                ...state,
                role: action.role,
            };

        case TopBar.SET_VIEW:
            return {
                ...state,
                view: action.view,
            };

        default:
            return state;
    }
};
